import dayjs from "dayjs";

import { yupLocalized } from "@ryde/shared";

export const bulkCloneFormValidationRules = {
  dateFrom: yupLocalized.string().required(),
  dateTo: yupLocalized
    .string()
    .required()
    .when("dateFrom", ([dateFrom], schema) => {
      if (dateFrom) {
        const dateTo = dayjs.utc(dateFrom).toISOString();

        if (dayjs.utc(dateTo) < dayjs.utc(dateFrom)) {
          return schema.min(
            dayjs.utc(dateTo).valueOf(),
            "End date has to be after than start date",
          );
        }
      }

      return schema;
    }),
};
